import React from "react";
import Users_Table from "./Facts_table";
import { Card, CardBody, CardHeader } from "reactstrap";

const Users_List = () => {
  return (
    <div>
      <Card>
        <CardHeader>لیست کاربران</CardHeader>
        <CardBody>
          <Users_Table />
        </CardBody>
      </Card>
    </div>
  );
};

export default Users_List;
